import { vuex as login } from './login'
import { vuex as course } from './course'
import { vuex as user } from './user'
import { vuex as channel } from './channel'
import { vuex as assessment } from './assessment'
import { vuex as learningContent } from './learningContent'
import { vuex as search } from './search'
import { vuex as dashboard } from './dashboard'
import { vuex as folderManagement } from './folderManagement'
import { vuex as semester } from './semester'
import { vuex as employer } from './employer'
import { vuex as job } from './job'
import { vuex as sharing } from './sharing'
import { vuex as stream } from './stream'
import { vuex as advancedSearch } from './advancedSearch'
import { vuex as quickLink } from './quickLink'
import { vuex as adviseeTracker } from './adviseeTracker'
import { vuex as club } from './club'
import { vuex as event } from './event'
import { vuex as institution } from './institution'
import { vuex as catalog } from './catalog'
import { vuex as guest } from './guest'
import { vuex as tool } from './tool'
import { vuex as quest } from './quest'
import { vuex as person } from './person'
import { vuex as career } from './career'
import { vuex as programguide } from './programguide'
import { vuex as coacheeTracker } from './coacheeTracker'
import { vuex as taskMonitor } from './taskMonitor'
import { vuex as explore } from './explore'
import { vuex as tagging } from './tagging'
import { vuex as help } from './help'
import { vuex as group } from './group'
import { vuex as connector } from './connector'
import { vuex as transfer } from './transfer'
import { vuex as widget } from './widget'
import { vuex as microCompetency } from './microCompetency'


export default { login, course, user, channel, assessment, learningContent, search, dashboard, folderManagement, semester, employer, job, sharing, stream, advancedSearch, quickLink, adviseeTracker, club, event, institution, catalog, guest, tool, person, quest, career, programguide, taskMonitor, coacheeTracker, explore, tagging, help, group, connector, transfer, widget, microCompetency }



// WEBPACK FOOTER //
// ./src/app/vuex.js